import PropTypes from 'prop-types'
import React from 'react'
import { FieldArray } from 'redux-form'
import { useTranslation } from 'react-i18next'
import LoginRow from 'modules/Forms/Account/Create/subcomponents/LoginField/LoginRow'

const MultiLoginField = (props) => {
  const { t } = useTranslation()

  return (
    <FieldArray
      name={'logins'}
      component={LoginRow}
      {...props}
      label={t('services::forms.shared_fields.logins.label')}
    />
  )
}

MultiLoginField.propTypes = {
  autofill: PropTypes.func,
  networkId: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  multiLogin: PropTypes.bool,
}

export default MultiLoginField
